import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBackDropOptions } from '@core/ui';
import { PromptDialogComponent } from '../prompt-dialog.component';

@Injectable({ providedIn: 'root' })
export class PromptDialogService {

  constructor(
    private dialog: MatDialog
  ) { }

  open(config: any): MatDialogRef<PromptDialogComponent> {
    return this.dialog.open(PromptDialogComponent, {
      ...DialogBackDropOptions,
      ...config
    });
  }
}
